import { Mark } from '@tiptap/core'

export const FocusMark = Mark.create({
  name: 'focusMark',
  inclusive: false,
  addOptions() {
    return {
      id: {},
      user_id: {
        default: null,
      },
    }
  },
  addAttributes() {
    return {
      id: {
        renderHTML: (attributes) => {
          return {
            id: attributes.id,
            ...attributes,
          }
        },
      },
      user_id: {},
    }
  },
  parseHTML() {
    return [
      {
        tag: 'span[id]',
      },
    ]
  },
  renderHTML({ HTMLAttributes }) {
    const style = 'background-color: rgba(255, 102, 179, 0.4);'
    HTMLAttributes.style = style
    return [
      'span',
      {
        ...HTMLAttributes,
        id: HTMLAttributes.id,
        'data-user-id': HTMLAttributes.user_id,
      },
      0,
    ]
  },
})
